var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopCategoriesSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 33.0074L32.9859 36.157L31.6609 30.213L36.1539 26.1391L30.2445 25.6147L28 20.0715L25.7555 25.6147L19.8462 26.1391L24.3391 30.213L23.0141 36.157L28 33.0074ZM22.8333 36.9681C22.8333 36.9681 22.8332 36.9682 22.8333 36.9681ZM18.3608 26.7045L22.7771 30.709L21.4505 36.66C21.2413 37.5979 22.2139 38.338 23.0024 37.84L28 34.683L32.9976 37.84C33.7861 38.338 34.7588 37.5979 34.5495 36.66L33.2229 30.709L37.6393 26.7045C38.3351 26.074 37.963 24.8771 37.0458 24.796L31.2325 24.2802L28.9585 18.664C28.5995 17.7787 27.4006 17.7787 27.0415 18.664L24.7675 24.2802L18.9542 24.796C18.037 24.8771 17.6648 26.074 18.3608 26.7045Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCategoriesSectionIcon);
export default __webpack_public_path__ + "static/media/top-categories-section-icon.ea3dba9ffc350f9404930625ae17511f.svg";
export { ForwardRef as ReactComponent };